import { render } from "./ColorBanner.vue?vue&type=template&id=29178e3a"
import script from "./ColorBanner.vue?vue&type=script&lang=js"
export * from "./ColorBanner.vue?vue&type=script&lang=js"

import "./ColorBanner.vue?vue&type=style&index=0&id=29178e3a&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__